/* ══════════════════════════════════════════════
   FUTURE FUND FINANCE — Site Data
   ══════════════════════════════════════════════ */

export const IMAGES = {
  hero:     'https://img.freepik.com/premium-photo/businessman-shaking-hands-giving-dollar-bills-business-manager_45041-162.jpg',
  home:     'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=800&q=80',
  car:      'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=800&q=80',
  usedcar:  'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&q=80',
  personal: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=800&q=80',
  business: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80',
  property: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
  invest:   'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80',
  team:     'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80',
  village:  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
  step1:    'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&q=80',
  step2:    'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=400&q=80',
  step3:    'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&q=80',
  step4:    'https://images.unsplash.com/photo-1534951009808-766178b47a4f?w=400&q=80',
};

export const LOANS = [
  {
    icon: '🏠',
    title: 'Home Loans',
    sub: 'Build Your Dream',
    desc: 'Turn your dream home into reality. Low EMIs, flexible tenure, doorstep service across India — villages to metro cities.',
    img: IMAGES.home,
    rate: '6.75%',
    tenure: '30 yrs',
  },
  {
    icon: '🚘',
    title: 'New Car Loans',
    sub: 'Drive Fresh',
    desc: '0-hassle financing for brand-new vehicles. On-road funding from all major banks with instant processing.',
    img: IMAGES.car,
    rate: '7.25%',
    tenure: '7 yrs',
  },
  {
    icon: '🚗',
    title: 'Used Car Loans',
    sub: 'Smart Choice',
    desc: 'Drive your dream car at affordable EMIs. Competitive rates on all certified pre-owned vehicles.',
    img: IMAGES.usedcar,
    rate: '8.50%',
    tenure: '5 yrs',
  },
  {
    icon: '💳',
    title: 'Personal Loans',
    sub: 'Any Need, Any Time',
    desc: 'Instant personal loans for travel, medical, education or emergencies. Minimal paperwork, maximum speed.',
    img: IMAGES.personal,
    rate: '10.5%',
    tenure: '5 yrs',
  },
  {
    icon: '📈',
    title: 'Business Loans',
    sub: 'Scale Up',
    desc: 'Tailored financing for MSMEs, startups, and enterprises. Fuel your growth with flexible repayment options.',
    img: IMAGES.business,
    rate: '11%',
    tenure: '10 yrs',
  },
  {
    icon: '🏢',
    title: 'Loan Against Property',
    sub: 'Unlock Value',
    desc: 'Get up to 75% of your property value at attractive rates. Secure funds for any purpose with your existing asset.',
    img: IMAGES.property,
    rate: '9.0%',
    tenure: '15 yrs',
  },
];

export const BANKS = [
  'Axis Bank',
  'HDFC Bank',
  'ICICI Bank',
  'AU Small Finance',
  'Kotak Mahindra',
  'Yes Bank',
  'IndusInd Bank',
  'All Private Banks',
  'All NBFCs',
];

export const FEATURES = [
  {
    icon: '📄',
    no: '01',
    title: 'Minimum Documentation',
    desc: 'We keep paperwork razor-thin. Basic KYC and income proof is all you need to start your loan journey.',
  },
  {
    icon: '💻',
    no: '02',
    title: '100% Online Process',
    desc: 'Apply from your phone or laptop. No branch visits, no queues. Everything done digitally.',
  },
  {
    icon: '🌍',
    no: '03',
    title: 'Pan-India Coverage',
    desc: 'We serve every corner of India — remote villages, tier-2 cities, metros, and multiple states.',
  },
  {
    icon: '⚡',
    no: '04',
    title: 'Fast Disbursement',
    desc: 'Funds credited to your account within 24–72 hours of approval. No waiting, no delays.',
  },
];

export const STEPS = [
  {
    no: '01',
    icon: '📝',
    title: 'Apply Online',
    desc: 'Fill our simple form in under 3 minutes from your phone or laptop. No branch visit needed.',
    img: IMAGES.step1,
  },
  {
    no: '02',
    icon: '📤',
    title: 'Upload Documents',
    desc: 'Securely upload minimal KYC documents digitally. Basic income proof is all it takes.',
    img: IMAGES.step2,
  },
  {
    no: '03',
    icon: '✅',
    title: 'Get Approved',
    desc: 'Our experts review your profile and match you with the best offer from top banks within hours.',
    img: IMAGES.step3,
  },
  {
    no: '04',
    icon: '💰',
    title: 'Receive Funds',
    desc: 'Money hits your account within 24–72 hours. No delays, no hidden fees, just funds.',
    img: IMAGES.step4,
  },
];

export const TESTIMONIALS = [
  {
    name: 'Rajesh Kumar',
    loc: 'Delhi',
    text: 'Got my home loan approved in just 3 days! Future Fund Finance made the whole process incredibly smooth.',
    stars: 5,
    loan: 'Home Loan',
  },
  {
    name: 'Priya Sharma',
    loc: 'Mumbai',
    text: 'Applied for a business loan online and got disbursed in 48 hours. Their team was very professional.',
    stars: 5,
    loan: 'Business Loan',
  },
  {
    name: 'Amit Patel',
    loc: 'Ahmedabad',
    text: 'Even in our village area, they helped me get a car loan with minimum documents. Truly amazing service!',
    stars: 5,
    loan: 'Car Loan',
  },
];

export const NAV_LINKS = ['Home', 'Services', 'Features', 'Banks', 'Process', 'Testimonials', 'Contact'];

export const CONTACT_INFO = [
  { icon: '📞', label: 'Call Us Anytime',  val: '+91 9634629999 || +91 9953252454' },
  { icon: '📧', label: 'Email',            val: 'info@futurefundfinance.in' },
  { icon: '🕐', label: 'Working Hours',    val: 'Mon–Sat: 9:00 AM – 7:00 PM' },
  { icon: '📍', label: 'Coverage',         val: 'All India – Villages, Cities & States' },
];
